import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useQueryParams } from '../../router/useQueryParams';
import { jsx as _jsx } from "react/jsx-runtime";
const INVITE_ALERT = 'invite';
const IMPORT_ALERT = 'import';

// Owned by # growth-onboarding-experienced-users
export function useShowDataManagementOnboardingAlert() {
  const {
    via
  } = useQueryParams();
  useEffect(() => {
    if (via === INVITE_ALERT) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "index.alerts.dataManagement.invite.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "index.alerts.dataManagement.invite.title"
        }),
        type: 'success'
      });
    } else if (via === IMPORT_ALERT) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "index.alerts.dataManagement.import.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "index.alerts.dataManagement.import.title"
        }),
        type: 'info'
      });
    }
  }, [via]);
}